module.exports = __webpack_public_path__ + "static/media/Item_Weapon_SKS_C.96e5eafb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_SKS_C.png
// module id = 242
// module chunks = 0